import { useState, useEffect } from "react";
import api from "../lib/ghost";

export interface GhostPost {
  id: string;
  title: string;
  tags: { name: string; slug: string }[];
  slug: string;
  html: string;
  feature_image?: string;
  published_at: string;
}

export default function useGhostPosts(limit = 5) {
  const [posts, setPosts] = useState<GhostPost[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    setLoading(true);
    api.posts
      .browse({ limit, include: "authors" })
      .then((data) => setPosts(data as GhostPost[]))
      .catch((err) => setError(err))
      .finally(() => setLoading(false));
  }, [limit]);

  return { posts, loading, error };
}
